import {
  BookingEngineServiceDTO,
  PreCheckInReservationItemServiceDTO,
  ReservationItemServiceDTO,
} from 'src/services/api/data-contracts';

export class IApiDropdownOption {
  Id: number;
  Text: string;
}
export interface IPropertyTheme {
  primary: string;
  secondary: string;
  accent: string;

  dark: string;
  darkPage: string;

  positive: string;
  negative: string;
  info: string;
  warning: string;

  lightPage: string;
  brandKey: string;
  brandBackground: string;
}

export interface IProblemDetails {
  type?: string;
  title: string;
  traceId?: string;
  status: number;
  errors?: IProblemDetailErrors;
  detail: string;
}

export interface IProblemDetailErrors {
  '': Array<string>;
  [key: string]: Array<string>;
}

export interface IReservationItemServiceDTO {
  ServiceId: number;
  Quantity: number;
}

export interface IReservationItemService extends IReservationItemServiceDTO {
  ServiceId: number;
  Service: BookingEngineServiceDTO;
  Quantity: number;
}

function instanceOfBookingEngineServiceDTO(
  data?:
    | PreCheckInReservationItemServiceDTO
    | ReservationItemServiceDTO
    | BookingEngineServiceDTO,
): data is BookingEngineServiceDTO {
  return (
    'ServiceCode' in data &&
    'ServiceName' in data &&
    'ServiceDescription' in data
  );
}

export class ReservationItemService {
  constructor(
    data?:
      | PreCheckInReservationItemServiceDTO
      | ReservationItemServiceDTO
      | BookingEngineServiceDTO,
  ) {
    if (!data) {
      return;
    }
    this.ServiceId = data.ServiceId;
    if (instanceOfBookingEngineServiceDTO(data)) {
      this.Service = data;
    } else {
      this.Service = data.Service;
      this.ReservationItemId = data.ReservationItemId;
      this.Quantity = data.Quantity;
    }
  }

  ReservationItemId: number;
  ServiceId: number;
  Service: BookingEngineServiceDTO;
  Quantity: number;

  roomId: string;

  toReservationItemServiceDTO(): ReservationItemServiceDTO {
    return {
      ServiceId: this.ServiceId ?? this.Service?.ServiceId,
      Quantity: this.Quantity,
    } as ReservationItemServiceDTO;
  }

  toDTO() {
    return {
      ServiceId: this.ServiceId ?? this.Service?.ServiceId,
      Quantity: this.Quantity,
    };
  }
}

export class ServiceInventory {
  ServiceId: number;
  StartingInventory?: number | null;
  ReservationItems: Array<ReservationItemService> = [];

  get UsedInventory(): number {
    return this.ReservationItems.reduce((a, b) => {
      return a + b.Quantity;
    }, 0);
  }
  get AvailableInventory(): number | null {
    const s = this.StartingInventory;
    if (s == null) {
      return null;
    }
    return s - this.UsedInventory;
  }
}
